import { defineComponent as o, toRef as n, ref as r, onBeforeUnmount as s, nextTick as f, h as u } from "vue";
import v from "./ghl-ui.es1571.js";
import c from "./ghl-ui.es908.js";
const w = o({
  name: "BaseWave",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    }
  },
  setup(t) {
    c("-base-wave", v, n(t, "clsPrefix"));
    const l = r(null), i = r(!1);
    let e = null;
    return s(() => {
      e !== null && window.clearTimeout(e);
    }), {
      active: i,
      selfRef: l,
      play() {
        e !== null && (window.clearTimeout(e), i.value = !1, e = null), f(() => {
          var a;
          (a = l.value) === null || a === void 0 || a.offsetHeight, i.value = !0, e = window.setTimeout(() => {
            i.value = !1, e = null;
          }, 1e3);
        });
      }
    };
  },
  render() {
    const {
      clsPrefix: t
    } = this;
    return u("div", {
      ref: "selfRef",
      "aria-hidden": !0,
      class: [`${t}-base-wave`, this.active && `${t}-base-wave--active`]
    });
  }
});
export {
  w as default
};
